/**
 * theme.js - Pulse Shokudo Shopify Theme
 * Main JavaScript entry point
 * Vanilla JS, no jQuery dependency
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ==========================================================================
     1. Swiper Carousel - Hero Slideshow
     ========================================================================== */

  (function initHeroSwiper() {
    var heroEl = document.getElementById('jsFv');

    if (!heroEl || typeof Swiper === 'undefined') return;

    // 端の表示をきれいにするためにページを二倍に増やす
    const newnodes = Array.from(heroEl.querySelectorAll('.swiper-slide')).map(e => e.cloneNode(true));
    newnodes.forEach(n => {
      heroEl.querySelector('.swiper-wrapper').appendChild(n);
    });

    new Swiper(heroEl, {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      pagination: {
        el: heroEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: heroEl.querySelector('.swiper-button-next'),
        prevEl: heroEl.querySelector('.swiper-button-prev')
      }
    });
  })();

  /* ==========================================================================
     2. Header Scroll Behavior
     ========================================================================== */

  (function initHeaderScroll() {
    var header = document.getElementById('jsHeader');
    if (!header) return;

    var lastScrollY = 0;
    var ticking = false;
    var SCROLL_THRESHOLD = 5;

    function onScroll() {
      var currentScrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (Math.abs(currentScrollY - lastScrollY) < SCROLL_THRESHOLD) {
        ticking = false;
        return;
      }

      if (currentScrollY > lastScrollY && currentScrollY > header.offsetHeight) {
        // Scrolling down - hide header
        header.classList.add('is-hidden');
      } else {
        // Scrolling up - show header
        header.classList.remove('is-hidden');
      }

      // Add scrolled state when not at the very top
      if (currentScrollY > 0) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    }, { passive: true });
  })();

  /* ==========================================================================
     3. Hamburger Menu Toggle
     ========================================================================== */

  (function initHamburgerMenu() {
    var toggleBtn = document.querySelector('.hamburger');
    var mobileNav = document.querySelector('.mobile-nav');
    if (!toggleBtn || !mobileNav) return;

    function openMenu() {
      toggleBtn.classList.add('is-active');
      toggleBtn.setAttribute('aria-expanded', 'true');
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      toggleBtn.classList.remove('is-active');
      toggleBtn.setAttribute('aria-expanded', 'false');
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function isOpen() {
      return mobileNav.classList.contains('is-open');
    }

    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen()) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    // Close when clicking outside the nav
    document.addEventListener('click', function (e) {
      if (isOpen() && !mobileNav.contains(e.target) && !toggleBtn.contains(e.target)) {
        closeMenu();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        closeMenu();
        toggleBtn.focus();
      }
    });
  })();

  /* ==========================================================================
     4. FAQ Accordion
     ========================================================================== */

  (function initFaqAccordion() {
    var questions = document.querySelectorAll('.faq--cnt-q');
    if (!questions.length) return;

    questions.forEach(function (question) {
      question.addEventListener('click', function () {
        var parent = this.parentElement;
        var answer = parent.querySelector('.faq--cnt-a');
        if (!answer) return;

        var isOpen = parent.classList.contains('is-open');

        // Optionally close other open items (accordion behavior)
        // Uncomment the block below to allow only one open at a time:
        /*
        questions.forEach(function (q) {
          var p = q.parentElement;
          var a = p.querySelector('.faq--cnt-a');
          if (p !== parent && p.classList.contains('is-open')) {
            p.classList.remove('is-open');
            slideUp(a);
          }
        });
        */

        if (isOpen) {
          parent.classList.remove('is-open');
          slideUp(answer);
        } else {
          parent.classList.add('is-open');
          slideDown(answer);
        }
      });
    });

    /**
     * Slide an element down (expand).
     * @param {HTMLElement} el
     * @param {number} duration - ms
     */
    function slideDown(el, duration) {
      duration = duration || 300;
      el.style.display = 'block';
      el.style.overflow = 'hidden';
      var height = el.scrollHeight;
      el.style.height = '0px';
      el.style.transition = 'height ' + duration + 'ms ease';

      // Force reflow
      el.offsetHeight; // eslint-disable-line no-unused-expressions

      el.style.height = height + 'px';

      setTimeout(function () {
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
      }, duration);
    }

    /**
     * Slide an element up (collapse).
     * @param {HTMLElement} el
     * @param {number} duration - ms
     */
    function slideUp(el, duration) {
      duration = duration || 300;
      el.style.overflow = 'hidden';
      el.style.height = el.scrollHeight + 'px';
      el.style.transition = 'height ' + duration + 'ms ease';

      // Force reflow
      el.offsetHeight; // eslint-disable-line no-unused-expressions

      el.style.height = '0px';

      setTimeout(function () {
        el.style.display = 'none';
        el.style.height = '';
        el.style.overflow = '';
        el.style.transition = '';
      }, duration);
    }
  })();

  /* ==========================================================================
     6. Product Gallery Thumbnail Click
     ========================================================================== */

  (function initProductGallery() {
    var mainImage = document.getElementById('product-main-image');
    var thumbs = document.querySelectorAll('.product-thumb');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();

        // Get the target image source from data attribute or nested img
        var newSrc = this.dataset.src
          || this.dataset.imageSrc
          || (this.querySelector('img') ? this.querySelector('img').src : null);

        if (!newSrc) return;

        // Update main image
        mainImage.setAttribute('src', newSrc);

        // If there is a srcset or data-srcset on the thumb, propagate it
        var newSrcset = this.dataset.srcset || '';
        if (newSrcset) {
          mainImage.setAttribute('srcset', newSrcset);
        }

        // Update active state
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
      });
    });
  })();

  /* ==========================================================================
     7. Filter Buttons (.select-btns)
     ========================================================================== */

  (function initFilterButtons() {
    var filterBtns = document.querySelectorAll('.select-btns');
    if (!filterBtns.length) return;

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        this.classList.toggle('selected');
      });
    });
  })();

  /* ==========================================================================
     8. Mobile Footer Accordion
     ========================================================================== */

  (function initMobileFooterAccordion() {
    var footerLinks = document.querySelectorAll('footer .page-link');
    if (!footerLinks.length) return;

    footerLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        // Only activate on mobile
        if (window.innerWidth > 768) return;

        var subMenu = this.querySelector('.page-map')
          || this.nextElementSibling;
        if (!subMenu || !subMenu.classList.contains('page-map')) return;

        e.preventDefault();

        var isOpen = this.classList.contains('is-open');

        // Close all other footer accordions
        footerLinks.forEach(function (fl) {
          if (fl !== link) {
            fl.classList.remove('is-open');
            var sm = fl.querySelector('.page-map')
              || fl.nextElementSibling;
            if (sm && sm.classList.contains('page-map')) {
              sm.style.display = 'none';
            }
          }
        });

        if (isOpen) {
          this.classList.remove('is-open');
          subMenu.style.display = 'none';
        } else {
          this.classList.add('is-open');
          subMenu.style.display = 'block';
        }
      });
    });
  })();

  /* ==========================================================================
     9. Smooth Scroll for Anchor Links
     ========================================================================== */

  (function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;

      var hash = anchor.getAttribute('href');
      if (!hash || hash === '#') return;

      var target;
      try {
        target = document.querySelector(hash);
      } catch (err) {
        return; // Invalid selector
      }
      if (!target) return;

      e.preventDefault();

      var header = document.getElementById('jsHeader');
      var headerOffset = header ? header.offsetHeight : 0;
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Update URL hash without jumping
      if (history.pushState) {
        history.pushState(null, null, hash);
      }
    });
  })();
});
